import React from 'react'
import PropTypes from 'prop-types'

import * as S from './styled'

const BaseLayout = ({ content: poster, ...rest }) => {
  const { text, ilustration, title } = poster

  return (
    <S.Container {...rest}>
      <S.TextBlock>
        <S.Decoration />
        <p className='description'>{text}</p>
        <p className='title'>{title}</p>
      </S.TextBlock>
      <S.Illustration illustration={ilustration} />
    </S.Container>
  )
}

BaseLayout.defaultProps = {
  content: {},
}

BaseLayout.propTypes = {
  content: PropTypes.object,
}

export default BaseLayout
